import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg'
import { Button } from 'components/common/button/Button'
import useHardNavigate from 'hooks/useHardNavigate'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

export const TopReturnToLandingButton = () => {
  const hardNavigate = useHardNavigate()

  return (
    <Button
      variant="navigationControlWhite"
      text="Experience Loop"
      className="absolute top-[110px] z-2 left-[68px]"
      iconLeft={<ChevronLeft />}
      border
      onClick={() => {
        hardNavigate('/')
        trackAnalytics({
          type: AnalyticsActionType.action,
          payload: EVENTS.ACTION.BACK_TO_LANDING_TOP,
        })
      }}
    />
  )
}
